import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import {
  Checkbox,
  FormControl,
  TextField,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
  TableHead,
  useMediaQuery,
  InputAdornment,
  CircularProgress,
  Box,
  IconButton,
  Typography,
  Divider
} from "@mui/material";
import { ArrowBack, Search, Clear, InfoOutlined, CheckCircle } from "@mui/icons-material";
import LoadingSpinner from "../../../Loading/component";
import { useTheme } from "@mui/material/styles";
import "./CohortAddVM.css";

export const CohortAddVmComponent = ({
  loading,
  seedData,
  selectedVM,
  handleVMSelection,
  handleUpdateVM,
  errors,
  cohortDetailsData,
  searchLoading,
  handleSearchInputChange,
  vmSearchInput,
  handleBulkVMPaste,
  pasteStatus,
  filteredTableData,
  handleClearSearch,
  handleClearAllFromLastPaste,
  handleClearAllSelected,
  tableContainerRef,
  getNewVMsToAdd,
  getAllCheckedVMs,
  existingVMs,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const newVMsToAdd = getNewVMsToAdd ? getNewVMsToAdd() : [];
  const allCheckedVMs = getAllCheckedVMs ? getAllCheckedVMs() : [];

  // Handle clear search button click
  const handleClearButtonClick = () => {
    if (handleClearSearch) {
      handleClearSearch();
    }
  };

  // Info about existing VMs in cohort
  const cohortInfo = cohortDetailsData ? (
    <div className="cohort-add-vm-info-section">
      <div className="cohort-add-vm-info-item">
        <span className="cohort-add-vm-info-label">Cohort Name:</span>
        <span className="cohort-add-vm-info-value">{cohortDetailsData.name || "N/A"}</span>
      </div>
      <div className="cohort-add-vm-info-item">
        <span className="cohort-add-vm-info-label">Existing VMs:</span>
        <span className="cohort-add-vm-info-value">{existingVMs.length}</span>
      </div>
      <div className="cohort-add-vm-info-item">
        <span className="cohort-add-vm-info-label">New VMs to Add:</span>
        <span className="cohort-add-vm-info-value highlight">{newVMsToAdd.length}</span>
      </div>
    </div>
  ) : null;

  // Separate existing VMs and new VMs for display
  const existingVMData = filteredTableData.filter(vm => 
    existingVMs.some(existing => existing.id === vm.id)
  );
  
  const newVMData = filteredTableData.filter(vm => 
    !existingVMs.some(existing => existing.id === vm.id)
  );

  return (
    <div className="cohort-add-vm-container">
      {loading && (
        <div className="cohort-add-vm-loading-overlay">
          <LoadingSpinner />
        </div>
      )}

      <Sidebar />

      <div className="cohort-add-vm-content-container">
        <div className="cohort-add-vm-header">
          <ArrowBack 
            className="cohort-add-vm-back-icon" 
            onClick={() => window.history.back()} 
          />
          <h2 className="cohort-add-vm-heading">Add Vending Machines</h2>
        </div>

        {cohortInfo}

        <div className="cohort-add-vm-form-container">
          <FormControl className="cohort-add-vm-form-control">
            <div className="cohort-add-vm-section-title">
              Select New VMs to Add
              <span className="cohort-add-vm-required">*</span>
            </div>

            <div className="cohort-add-vm-search-container">
              {/* Search Input with Bulk Paste */}
              <div className="cohort-add-vm-search-wrapper">
                <TextField
                  variant="outlined"
                  placeholder="Search by VM ID/Name or paste comma-separated IDs"
                  value={vmSearchInput}
                  onChange={handleSearchInputChange}
                  autoComplete="off"
                  onPaste={handleBulkVMPaste}
                  fullWidth
                  className="cohort-add-vm-search-input"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search fontSize="small" className="cohort-add-vm-search-icon" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        {searchLoading && <CircularProgress size={20} className="cohort-add-vm-search-loading" />}
                        {vmSearchInput && !searchLoading && (
                          <IconButton 
                            size="small" 
                            onClick={handleClearButtonClick}
                            className="cohort-add-vm-clear-button"
                          >
                            <Clear fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    )
                  }}
                />

                {/* Search Tips */}
                {/* <div className="cohort-add-vm-search-tips">
                  <InfoOutlined fontSize="small" />
                  <span>Tip: You can paste multiple VM IDs separated by commas or new lines</span>
                </div> */}

                {/* Paste Status Message */}
                {pasteStatus && (
                  <div className={`cohort-add-vm-status-message cohort-add-vm-status-${pasteStatus.severity}`}>
                    {pasteStatus.message}
                  </div>
                )}

                {/* Search Results Info */}
                {vmSearchInput && filteredTableData.length > 0 && (
                  <div className="cohort-add-vm-search-results-info">
                    Found {filteredTableData.length} VM(s)
                  </div>
                )}

                {/* No Results Message */}
                {vmSearchInput && filteredTableData.length === 0 && (
                  <div className="cohort-add-vm-no-results">
                    <Typography variant="body2">
                      No VMs found matching: "{vmSearchInput}"
                    </Typography>
                  </div>
                )}
              </div>

              {/* Selected Count Info */}
              {/* {selectedVM.length > 0 && (
                <div className="cohort-add-vm-selected-info">
                  <div className="cohort-add-vm-selected-stats">
                    <div className="cohort-add-vm-stat-item">
                      <span className="cohort-add-vm-stat-label">New Selected:</span>
                      <span className="cohort-add-vm-stat-value highlight">{selectedVM.length}</span>
                    </div>
                    <div className="cohort-add-vm-stat-item">
                      <span className="cohort-add-vm-stat-label">Existing in Cohort:</span>
                      <span className="cohort-add-vm-stat-value">
                        {existingVMs.length}
                      </span>
                    </div>
                  </div>
                  
                  <div className="cohort-add-vm-clear-buttons">
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleClearAllFromLastPaste}
                      className="cohort-add-vm-clear-paste-button"
                      disabled={selectedVM.length === 0}
                    >
                      Clear Last Paste
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      color="error"
                      onClick={handleClearAllSelected}
                      className="cohort-add-vm-clear-all-button"
                      disabled={selectedVM.length === 0}
                    >
                      Clear All New
                    </Button>
                  </div>
                </div>
              )} */}

              {errors?.selectedVM && (
                <div className="cohort-add-vm-error-message">
                  {errors.selectedVM}
                </div>
              )}
            </div>

            {/* VM Selection Table */}
            <div className="cohort-add-vm-table-wrapper">
              <TableContainer
                component={Paper}
                className="cohort-add-vm-table-container"
                ref={tableContainerRef}
              >
                <Table stickyHeader className="cohort-add-vm-table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="cohort-add-vm-table-header select-col">Select</TableCell>
                      <TableCell className="cohort-add-vm-table-header id-col">VM ID</TableCell>
                      <TableCell className="cohort-add-vm-table-header name-col">VM Name</TableCell>
                      {/* <TableCell className="cohort-add-vm-table-header status-col">Status</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Section 1: Existing VMs in Cohort */}
                    {existingVMData.length > 0 && (
                      <>
                        <TableRow className="cohort-add-vm-section-header">
                        
                        </TableRow>
                        {existingVMData.map((machine, index) => {
                          const isChecked = true; // Always checked for existing VMs
                          
                          return (
                            <TableRow
                              key={`existing-${machine.id}`}
                              className="cohort-add-vm-table-row existing"
                            >
                              <TableCell className="cohort-add-vm-table-cell select-cell">
                                <Checkbox
                                  checked={isChecked}
                                  disabled
                                  className="cohort-add-vm-checkbox existing-checkbox"
                                  size="small"
                                />
                              </TableCell>
                             <TableCell className="cohort-add-vm-table-cell name-cell">
                                {machine.id || "N/A"}
                              </TableCell>
                              <TableCell className="cohort-add-vm-table-cell name-cell">
                                {machine.name || "N/A"}
                              </TableCell>
                              {/* <TableCell className="cohort-add-vm-table-cell status-cell">
                                <span className="cohort-add-vm-status-badge existing">Already in Cohort</span>
                              </TableCell> */}
                            </TableRow>
                          );
                        })}
                      </>
                    )}

                    {/* Section 2: New VMs (Available for selection) */}
                    {newVMData.length > 0 && (
                      <>
                        <TableRow className="cohort-add-vm-section-header new-section">
                      
                        </TableRow>
                        {newVMData.map((machine, index) => {
                          const isSelected = selectedVM.some(vm => vm.id === machine.id);
                          
                          return (
                            <TableRow
                              key={`new-${machine.id}`}
                              className={`cohort-add-vm-table-row ${isSelected ? 'selected' : index % 2 === 0 ? 'even' : 'odd'}`}
                            >
                              <TableCell className="cohort-add-vm-table-cell select-cell">
                                <Checkbox
                                  checked={isSelected}
                                  onChange={(e) => handleVMSelection(machine, e.target.checked)}
                                  className={`cohort-add-vm-checkbox ${isSelected ? 'selected' : ''}`}
                                  size="small"
                                />
                              </TableCell>
                              <TableCell className="cohort-add-vm-table-cell id-cell">
                                {/* <div className="cohort-add-vm-id-wrapper">
                                  <span className="cohort-add-vm-id">{machine.id}</span>
                                  {isSelected && (
                                    <span className="cohort-add-vm-selected-badge">Selected</span>
                                  )}

                                </div> */}
                                {machine.id || "N/A"}
                              </TableCell>
                              <TableCell className="cohort-add-vm-table-cell name-cell">
                                {machine.name || "N/A"}
                              </TableCell>
                              {/* <TableCell className="cohort-add-vm-table-cell status-cell">
                                {isSelected ? (
                                  <span className="cohort-add-vm-status-badge selected">New Selection</span>
                                ) : (
                                  <span className="cohort-add-vm-status-badge available">Available</span>
                                )}
                              </TableCell> */}
                            </TableRow>
                          );
                        })}
                      </>
                    )}

                    {/* No Data Message */}
                    {filteredTableData.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={4} className="cohort-add-vm-no-data">
                          {vmSearchInput ? 
                            `No VM found matching "${vmSearchInput}"` : 
                            "Loading available VMs..."
                          }
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            {/* Action Button */}
            <div className="cohort-add-vm-action-section">
              <Button
                variant="contained"
                className="cohort-add-vm-add-button"
                onClick={handleUpdateVM}
                disabled={newVMsToAdd.length === 0}
                fullWidth
                size="large"
              >
                {newVMsToAdd.length === 0 
                  ? "Select New VMs to Add" 
                  : `Add ${newVMsToAdd.length} New VM${newVMsToAdd.length > 1 ? 's' : ''} to Cohort`
                }
              </Button>
              
              {/* {newVMsToAdd.length > 0 && (
                <div className="cohort-add-vm-action-info">
                  <Typography variant="body2" color="textSecondary">
                    Note: Only {newVMsToAdd.length} new VM(s) will be added. Existing {existingVMs.length} VM(s) in the cohort will remain unchanged.
                  </Typography>
                </div>
              )} */}
            </div>
          </FormControl>
        </div>
      </div>
    </div>
  );
};

export default CohortAddVmComponent;